import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export enum CancellationReasonAppComplicatedOption {
  LearnMore = 'learnMore',
  CancelAnyway = 'cancelAnyway'
}

export function getCancellationReasonAppComplicatedStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.CancellationReasonAppComplicated,
    type: 'single-select',
    wordings: {
      title: t(`${ManageSubscriptionStepId.CancellationReasonAppComplicated}.${title}`)
    },
    options: [
      {
        id: CancellationReasonAppComplicatedOption.LearnMore,
        label: t(`${ManageSubscriptionStepId.CancellationReasonAppComplicated}.${options}.${CancellationReasonAppComplicatedOption.LearnMore}`)
      },
      {
        id: CancellationReasonAppComplicatedOption.CancelAnyway,
        label: t(`${ManageSubscriptionStepId.CancellationReasonAppComplicated}.${options}.${CancellationReasonAppComplicatedOption.CancelAnyway}`)
      }
    ]
  }
}
